/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Body_PhotoInputs */

const en_us2_search_field_body_photo = /** @type {(inputs: Search_Field_Body_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Body assessment from photos`)
};

const pt_br2_search_field_body_photo = /** @type {(inputs: Search_Field_Body_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avaliação corporal por foto`)
};

const es_419_search_field_body_photo = /** @type {(inputs: Search_Field_Body_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evaluación corporal con fotos`)
};

const pt_pt2_search_field_body_photo = /** @type {(inputs: Search_Field_Body_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avaliação corporal por foto`)
};

const fr_fr2_search_field_body_photo = /** @type {(inputs: Search_Field_Body_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Évaluation corporelle par photo`)
};

const de_de2_search_field_body_photo = /** @type {(inputs: Search_Field_Body_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Körperanalyse per Foto`)
};

const it_it2_search_field_body_photo = /** @type {(inputs: Search_Field_Body_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valutazione corporea da foto`)
};

/**
* | output |
* | --- |
* | "Body assessment from photos" |
*
* @param {Search_Field_Body_PhotoInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_body_photo = /** @type {((inputs?: Search_Field_Body_PhotoInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Body_PhotoInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_body_photo(inputs)
	if (locale === "es-419") return es_419_search_field_body_photo(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_body_photo(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_body_photo(inputs)
	if (locale === "de-DE") return de_de2_search_field_body_photo(inputs)
	if (locale === "it-IT") return it_it2_search_field_body_photo(inputs)
	return en_us2_search_field_body_photo(inputs)
});
export { search_field_body_photo as "search.field_body_photo" }